export enum IInvoiceType {
  Standard = 'standard',
  Quick = 'quick',
}

export enum IInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Pending = 'pending',
  Paid = 'paid',
  Cancelled = 'cancelled',
  Refunded = 'refunded',
  PartiallyRefunded = 'partially_refunded',
  Deleted = 'deleted',
  Dispute = 'dispute',
  Failed = 'failed',
  Succeeded = 'succeeded',
  Overdue = 'overdue',
}

export enum IPaymentType {
  Terminal = 'terminal',
  Card = 'card',
  Cash = 'cash',
  HsaFsa = 'hsa_fsa',
  Affirm = 'affirm',
}

export enum IUpdateSource {
  Create = 'create',
  Checkout = 'checkout',
  Edit = 'edit',
}

export enum IActionType {
  CopyLink = 'copy_link',
  SendReminder = 'send_reminder',
  MakePayment = 'make_payment',
  CancelInvoice = 'cancel_invoice',
  DeleteInvoice = 'delete_invoice',
  ViewReceipt = 'view_receipt',
  RefundPayment = 'refund_payment',
  SendReceipt = 'send_receipt',
  CreateQuickInvoice = 'create_quick_invoice',
  CreateStandardInvoice = 'create_standard_invoice',
  EditNote = 'edit_note',
  EditInvoice = 'edit_invoice',
  DeleteNote = 'delete_note',
  AddNote = 'add_note',
}

export enum IPageType {
  Invoice = 'invoice',
  Transaction = 'transaction',
  Patient = 'patient',
}

export enum IItemType {
  Invoice = 'invoice',
  Transaction = 'transaction',
  Patient = 'patient',
}
